import React from "react";
import i18next from 'i18next';
import ButtonBorder from "../../../Button/ButtonBorder";
import classNames from "classnames";
import Icon from "../../../Icon/Icon";
import Summary from "../../../Summary/Summary";
import lockCloseIcon from "icons/lock-close.svg";


class EventBlock extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { logo, team, bet, right = false } = this.props;

    return (
      <div className={ classNames("event-block", { right }) }>
        <div className="event-block__logo">
          <img src={ logo }/>
        </div>

        <div className="event-block__team">{ team }</div>

        <Summary className="event-block__summary">
          { bet && (
            <span className="event-block__main-bet"><span
              className="yellow">{ bet["market"] }</span>, { bet["name"] }</span>
          ) }
          <div>
            <span>{i18next.t('cf_full')}</span>
            { bet && bet.status && bet.cf ? (
              <span className="yellow">{ bet.cf.toFixed(2) }</span>
            ) : (
              <Icon glyph={ lockCloseIcon }/>
            ) }
          </div>
        </Summary>

        { bet && bet.status && (
          <ButtonBorder onClick={ bet.toggleBet } className="event-block__do-stake">
            { !bet.selected ? i18next.t('event_block.bet') : i18next.t('event_block.cancel') }
          </ButtonBorder>
        ) }

        <div className="event-block__chance-bar">
          <span style={ { height: `${bet ? bet["chance"] : 50}%` } }/>
        </div>
      </div>
    );
  }
}

export default EventBlock;


// WEBPACK FOOTER //
// ./app/components/EsportsGame/EventPage/EventBlock/EventBlock.jsx